<script setup lang="ts">
import {ref} from "vue";

const isOpen = ref(false)
const emit = defineEmits<{
  (e: "close", value: boolean): void
}>()

</script>

<template>
  <UModal v-model:open="isOpen">

    <template #footer>
      <div class="flex gap-2 justify-end">
        <UButton
            color="neutral"
            variant="outline"
            label="إلغاء"
            @click="emit('close', false)"
        />
        <UButton
            label="تأكيد"
            @click="emit('close', true)"
        />
      </div>
    </template>
  </UModal>
</template>

